<template>
  <div class="paper-container" style="display: flex">
    <div class="side">
      <div class="subject">
        <Subject @subClick="handleSub" @requestAll="handleAll"></Subject>
      </div>
      <Year
        :sideList="yearList"
        @yearClick="handleYear"
        @requestAll="handleAll2"
      ></Year>
    </div>
    <div class="content">
      <div v-if="itemList.length > 0 || scrollFlag">
        <Item
          v-for="(v, i) in itemList"
          :key="i"
          :curcer="v.articleId"
          :every="v"
          @itemClick="goDetail(v)"
        ></Item>
        <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
      </div>
      <NoData v-if="itemList.length == 0 && !scrollFlag"></NoData>
    </div>
  </div>
</template>

<script>
import Subject from "@/components/pager/Subject.vue";
import Year from "@/components/pager/Year.vue";
import Item from "@/components/pager/Item";
import mixin from "@/mixins/esIndex";
import Scroll from "@/components/paging/scroll";
import NoData from "@/views/PCView/search/components/NoData.vue";
export default {
  components: {
    Item,
    Year,
    Subject,
    Scroll,
    NoData,
  },
  mixins: [mixin],
  data() {
    return {
      params: {
        articleType: 2,
        paramStr: this.$route.query.paramStr,
        searchType:this.$route.query.searchType,
      },
    };
  },
  created() {
    this.getSearchList(this.params);
    this.getYearList(); // 年份
  },
  methods: {
    goDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/concentrationDetails",
        query: {
          type: e.articleType,
          id: e.articleId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/public.scss";
::v-deep .ivu-tree-empty {
  margin: 30px;
}
.subject {
  height: 559px;
  background-color: #fff;
  margin-bottom: 9px;
  h2 {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    margin: 27px 0px 0 30px;
  }
  .ivu-tree {
    margin: 0 13px;
  }
}
.side {
  width: 300px;
  margin-right: 11px;
}
</style>
